import React from "react";
import { Box } from "@mui/material";
import AdminHome from "../component/AdminHome";

function App() {
  return (

      <Box display="flex" height="100vh">
        <Box flex={1} display="flex">
          <Box flex={3} p={2}>
            <AdminHome />
          </Box>
        </Box>
      </Box>
 );
}

export default App;
